import React from "react";
import styled from 'styled-components';
import Tabs from "../../components/Tabs";
import {useHistory} from "react-router-dom";

export function ScalePrintTabs() {
  const history = useHistory();
  const activeTab = history.location.pathname;

  return (
    <StyledTabs>
      <Tabs.Tab
        to="/devices/scale-configurations"
        active={activeTab === "/devices" || activeTab.startsWith("/devices/scale-configurations")}
      >
        Scale Configurations
      </Tabs.Tab>
      <Tabs.Tab
        to="/devices/print-layouts"
        active={activeTab.startsWith("/devices/print-layouts")}
      >
        Print Layouts
      </Tabs.Tab>
      <Tabs.Tab
        to="/devices/printer-configurations"
        active={activeTab.startsWith("/devices/printer-configurations")}
      >
        Printers
      </Tabs.Tab>
    </StyledTabs>
  );
}

const StyledTabs = styled(Tabs)`
  margin-bottom: 2rem;
`;